import { useEffect } from "react";

import { scrollToElementWithRetry } from "@jti/ui/utils/scrollToElementWithRetry";

const stringParamName = "scrollTo";

const ScrollToElement: React.FC = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.has(stringParamName)) {
      scrollToElementWithRetry(params.get(stringParamName) || "");
    }
  }, []);

  return null;
};

export default ScrollToElement;
